import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const LoginSchema = z.object({
  email: z
    .string({
      required_error: i18nMessage("shared:forms.login.emailRequired"),
      invalid_type_error: i18nMessage("shared:forms.login.emailInvalidType"),
    })
    .trim()
    .email(i18nMessage("validation:invalidEmail")),
  password: z
    .string({
      required_error: i18nMessage("shared:forms.login.passwordRequired"),
    })
    .min(1, i18nMessage("shared:forms.login.passwordRequired")),
});

export type LoginFormData = z.infer<typeof LoginSchema>;
